export const DUNGEON_ENTRANCE_SCHEMA_VERSION = 1;
export const DUNGEON_ENTRANCE_GENERATOR_VERSION = '1.0.0';
export const DEFAULT_DUNGEON_ENTRANCE_RADII = Object.freeze({
    interactionRadius: 4,
    previewRevealRadius: 120,
    generationRadius: 180,
    resetRadius: 240,
});
export const DUNGEON_ENTRANCE_PART_KINDS = [
    'platform',
    'arch',
    'column',
    'buttress',
    'spire',
    'crown',
    'portal',
    'omen-panel',
    // O-025: the corbel pair that carries the forward-set omen panel back onto the arch.
    'omen-corbel',
    'icon-slot',
    'interact-anchor',
];
export const DUNGEON_ENTRANCE_PRIMITIVES = [
    'box',
    'cylinder',
    'arch',
    'plane',
    'ring',
    'icon',
];
export class DungeonEntranceError extends Error {
    problems;
    constructor(problems) {
        super(`procedural dungeon entrance failed:\n${problems.map((problem) => `${problem.path}: ${problem.message}`).join('\n')}`);
        this.problems = problems;
        this.name = 'DungeonEntranceError';
    }
}
//# sourceMappingURL=entrance-types.js.map